import { render } from "./Confirm.vue?vue&type=template&id=6338239b&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"

import "./Confirm.vue?vue&type=style&index=0&id=6338239b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6338239b"

export default script